/* ---------------------------------------------------------------------
   Le cadeau Black Friday : une paire de REDMI Buds 6 Play avec tout
   REDMI Note 17, Note 17 Pro ou Note 17 Pro Max.

   La remise automatique de Shopify met bien le cadeau a 0 F, mais elle
   ne sait pas l'ajouter au panier : Shopify n'ajoute jamais un article
   de lui-meme. C'est ce script qui s'en charge.

   Il le retire aussi quand le telephone quitte le panier. Sans cela, la
   remise cesse de s'appliquer et le client repartirait avec des
   ecouteurs factures 10 000 F qu'il n'a jamais demandes : c'est la
   moitie du travail, et la moitie qu'on oublie.

   Deux passages delicats sont traites a part, parce que la page du
   panier travaille en liens et en formulaire, pas en fetch :

   - le retrait d'une ligne est un simple lien vers /cart/change. On
     l'intercepte, on fait le changement en arriere-plan, on accorde le
     cadeau, et seulement apres on recharge. Sans cela le client voit
     une seconde ses ecouteurs reapparaitre a 10 000 F.
   - le bouton « Passer la commande » part directement au paiement. On
     applique d'abord les quantites saisies, on accorde, puis on part.
     Autrement un panier modifie a la main arriverait au paiement avec
     un cadeau que la remise ne couvre plus.

   La ligne du cadeau porte la propriete "Cadeau". C'est ce qui la
   distingue d'une paire que le client aurait achetee lui-meme, et a
   laquelle il ne faut surtout pas toucher.

   La liste des telephones vient de la collection REDMI Note 17 Series,
   la meme que la remise automatique. Un modele ajoute a la collection
   est donc couvert des deux cotes, sans toucher au code.
   --------------------------------------------------------------------- */
(function () {
  'use strict';

  var source = document.getElementById('mi-cadeau-cfg');
  if (!source) return;

  var cfg = {};
  try { cfg = JSON.parse(source.textContent) || {}; } catch (e) { return; }
  if (!cfg.cadeau || !cfg.prod || !cfg.prod.length) return;

  var MARQUE = cfg.marque || 'Offert';
  var enCours = false;
  var minuteur = null;

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function poster(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function () { return true; });
  }

  /* Lit le panier et remet le cadeau d'accord avec lui. Rend une
     promesse : vrai si quelque chose a bouge. */
  function reconcilier() {
    return json('/cart.js').then(function (panier) {
      var items = (panier && panier.items) || [];
      var telephones = 0;
      var ligne = null;

      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (cfg.prod.indexOf(it.product_id) >= 0) telephones += it.quantity;
        if (it.variant_id === cfg.cadeau && it.properties && it.properties.Cadeau) ligne = it;
      }

      if (telephones > 0 && !ligne) {
        return poster('/cart/add.js', { items: [{ id: cfg.cadeau, quantity: 1, properties: { Cadeau: MARQUE } }] });
      }
      if (telephones === 0 && ligne) {
        return poster('/cart/change.js', { id: ligne.key, quantity: 0 });
      }
      if (telephones > 0 && ligne && ligne.quantity !== 1) {
        return poster('/cart/change.js', { id: ligne.key, quantity: 1 });
      }
      return false;
    });
  }

  function accorder() {
    if (enCours) return;
    enCours = true;
    reconcilier().then(function (change) {
      enCours = false;
      if (change) rafraichir();
    }, function () {
      enCours = false;
    });
  }

  function rafraichir() {
    /* Sur la page panier, le total affiche vient d'etre fausse : on
       recharge. La passe suivante ne trouvera rien a changer, donc pas
       de boucle. Ailleurs on se contente du compteur ; le tiroir se
       remplira a sa prochaine ouverture. */
    if (surPanier()) { window.location.reload(); return; }
    json('/cart.js').then(function (p) {
      var n = p.item_count;
      var cibles = document.querySelectorAll('[data-cc],[data-cart-count],.cart-count,.cart-count-bubble,#CartCount');
      for (var i = 0; i < cibles.length; i++) {
        cibles[i].textContent = n;
        if (n > 0 && cibles[i].hasAttribute('hidden')) cibles[i].removeAttribute('hidden');
      }
    }).catch(function () {});
  }

  function surPanier() {
    return (document.body && /\bt-cart\b/.test(document.body.className)) ||
           /^\/cart(\/|$|\?)/.test(window.location.pathname);
  }

  function recharger() { window.location.reload(); }

  /* Sur la page panier, la ligne du cadeau perd ses commandes de
     quantite et son lien « Retirer ». Les rendre cliquables serait
     malhonnete : le script les annulerait aussitot, et le client
     croirait la boutique cassee. Le champ de quantite reste dans la
     page, simplement cache, sinon le formulaire enverrait les
     quantites decalees d'une ligne. */
  function habillerCadeau() {
    if (!surPanier()) return;
    var lignes = document.querySelectorAll('.ct-it');
    for (var i = 0; i < lignes.length; i++) {
      var props = lignes[i].querySelector('.props');
      if (!props || !/Cadeau\s*:/.test(props.textContent)) continue;

      var qy = lignes[i].querySelector('.ct-qy');
      if (qy) qy.style.display = 'none';
      var rm = lignes[i].querySelector('.ct-rm');
      if (rm) rm.style.display = 'none';

      var rgt = lignes[i].querySelector('.rgt');
      if (rgt && !rgt.querySelector('.mi-offert')) {
        var badge = document.createElement('span');
        badge.className = 'mi-offert';
        badge.textContent = 'Offert';
        badge.style.cssText = 'display:inline-flex;align-items:center;font-size:11.5px;font-weight:700;color:#1B6B3A;background:#E8F6EC;border-radius:999px;padding:6px 13px;letter-spacing:.2px';
        rgt.insertBefore(badge, rgt.firstChild);
      }
    }
  }

  function programmer() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { accorder(); }, 350);
  }

  /* On ecoute les appels au panier sans jamais les modifier. Glisser le
     cadeau dans la meme requete que le telephone aurait fait plus joli
     dans le tiroir, mais /cart/add.js est tout ou rien : si les
     ecouteurs manquent en stock, le telephone ne serait pas ajoute non
     plus. On ne met pas une vente en jeu pour un cadeau. */
  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var promesse = fetchOrigine.apply(this, arguments);
    try {
      var e = arguments[0];
      var url = typeof e === 'string' ? e : (e && e.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) promesse.then(programmer, programmer);
    } catch (err) {}
    return promesse;
  };

  /* Les liens « Retirer », « + » et « - » de la page panier. */
  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
    var cible = ev.target;
    if (!cible || !cible.closest) return;
    var lien = cible.closest('a[href*="/cart/change"]');
    if (!lien || lien.target) return;

    var href = lien.getAttribute('href') || '';
    var ligne = /[?&]line=(\d+)/.exec(href);
    var qte = /[?&]quantity=(\d+)/.exec(href);
    if (!ligne || !qte) return;

    ev.preventDefault();
    if (enCours) return;
    enCours = true;
    lien.style.opacity = '.45';
    lien.style.pointerEvents = 'none';

    poster('/cart/change.js', { line: parseInt(ligne[1], 10), quantity: parseInt(qte[1], 10) })
      .then(reconcilier)
      .then(recharger, recharger);
  }, true);

  /* Le bouton « Passer la commande ». */
  (function verrouPaiement() {
    var form = document.querySelector('form[action*="/cart"][method="post"]');
    if (!form || !surPanier()) return;

    var dernier = null;
    form.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('button') : null;
      if (b) dernier = b;
    }, true);

    form.addEventListener('submit', function (ev) {
      var b = ev.submitter || dernier;
      if (!b || b.name !== 'checkout') return;
      ev.preventDefault();
      b.disabled = true;

      var champs = form.querySelectorAll('input[name="updates[]"]');
      var quantites = [];
      for (var i = 0; i < champs.length; i++) quantites.push(parseInt(champs[i].value, 10) || 0);

      var corps = { updates: quantites };
      var note = form.querySelector('[name="note"]');
      if (note) corps.note = note.value;

      function partir() { window.location.href = '/checkout'; }
      poster('/cart/update.js', corps).then(reconcilier).then(partir, partir);
    }, true);
  })();

  function demarrer() { habillerCadeau(); accorder(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  /* Retour par le bouton precedent : la page sort du cache avec un
     panier peut-etre different de ce qu'elle affiche. */
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) accorder(); });
})();
